module.exports = __webpack_public_path__ + "static/img/loading.150c23d1.gif";